import React from 'react';
import { Repeat } from 'lucide-react';
import { tomorrowLabel } from '../../utils/dtdCutoff';

// Pop-up shown before a REGULAR customer pays for 3, 6 or 12 months of CableTV while the automatic
// box swap is on — see utils/longTermNotice.js. Nothing is charged until "I understand".
// `audience` picks the wording: 'customer' (portal) or 'staff' (CRM collect panel, agent app).
export default function LongTermRegularNotice({ audience = 'customer', months, at, onConfirm, onCancel }) {
  const date = tomorrowLabel(at || new Date());
  const isStaff = audience === 'staff';
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 10000, padding: 16,
    }} onClick={onCancel}>
      <div role="dialog" aria-modal="true" aria-labelledby="long-term-title" style={{
        background: '#fff', borderRadius: 14, width: '100%', maxWidth: 400,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', padding: '22px 20px',
      }} onClick={(e) => e.stopPropagation()}>
        <div style={{
          width: 46, height: 46, borderRadius: 12, background: '#dbeafe', display: 'flex',
          alignItems: 'center', justifyContent: 'center', marginBottom: 14,
        }}>
          <Repeat size={22} color="#1d4ed8" />
        </div>
        <div id="long-term-title" style={{ fontSize: '1.02rem', fontWeight: 800, color: '#1e293b', marginBottom: 8 }}>
          {months}-month recharge
        </div>
        {isStaff ? (
          <div style={{ fontSize: '.87rem', color: '#475569', lineHeight: 1.55 }}>
            This is a regular customer paying for <b>{months} months</b>. Tomorrow, <b>{date}</b>, after 9:30 AM
            the system will automatically swap their box on GTPL Saathi and place the {months}-month order.
            <div style={{ marginTop: 8 }}>
              When the {months} months they paid for end, they will be switched to <b>DTD</b> instead of going back to monthly billing.
            </div>
            <div style={{ marginTop: 8 }}>Please tell the customer their channels will be updated tomorrow.</div>
          </div>
        ) : (
          <div style={{ fontSize: '.87rem', color: '#475569', lineHeight: 1.55 }}>
            Dear customer, you are paying for <b>{months} months</b>. Your box will be updated tomorrow, <b>{date}</b>,
            after 9:30 AM and your {months}-month pack will be switched on then.
            <div style={{ marginTop: 8 }}>
              When your {months} months end, your plan will move to <b>DTD</b> (recharge whenever it is due) instead of monthly billing.
            </div>
          </div>
        )}
        <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
          <button type="button" className="btn btn-secondary" onClick={onCancel} style={{ flex: 1, justifyContent: 'center' }}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={onConfirm} style={{ flex: 2, justifyContent: 'center' }} autoFocus>
            I understand, continue
          </button>
        </div>
      </div>
    </div>
  );
}
